module.exports = __webpack_public_path__ + "media/מחבת.da1f926e.mp3";